import { format, parseISO } from "date-fns";

// Range pickers hold "YYYY-MM-DD" strings ("" = not picked); the calendar wants Dates.
export const toDate = (s) => (s ? parseISO(s) : undefined);
export const toIso = (d) => (d ? format(d, "yyyy-MM-dd") : "");
const show = (s) => format(parseISO(s), "d MMM yyyy");

/** "3 Oct 2026 – 18 Oct 2026", with "…" for an open end. */
export const rangeText = (value) => `${value.from ? show(value.from) : "…"} – ${value.to ? show(value.to) : "…"}`;
